import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';

import classes from './panel-header-scss';

type PanelHeaderProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
};

export const PanelHeader: React.FC<PanelHeaderProps> = ({ title, subtitle, className }) => {
  return (
    <div data-drag-handler="true">
      <SidePanel.Header
        showDivider
        className={classNames(classes.header, className)}
        title={title}
        subtitle={subtitle}
      />
    </div>
  );
};
